import React from "react";
import { useSelector } from "react-redux";

function AITools() {
  const es_en = useSelector((state) => state.translation);
  return (
    <div className="skills__content">
      <h3 className="skills__title">
        {es_en ? "AI Tools" : "Herramientas IA"}
      </h3>
      <div className="skills__box">
        <div className="skills__group">
          <div className="skills__data">
            <i className="bx bx-brain"></i>
            <div>
              <h3 className="skills__name">Claude</h3>
            </div>
          </div>
          <div className="skills__data">
            <box-icon name="github" type="logo" color="#98ca3f"></box-icon>
            <div>
              <h3 className="skills__name">GitHub Copilot</h3>
            </div>
          </div>
          <div className="skills__data">
            <i className="bx bx-bot"></i>
            <div>
              <h3 className="skills__name">Antigravity</h3>
            </div>
          </div>
          <div className="skills__data">
            <i className="bx bx-diamond"></i>
            <div>
              <h3 className="skills__name">Gemini Pro</h3>
            </div>
          </div>
        </div>
        <div className="skills__group">
          <div className="skills__data">
            <box-icon name="github" type="logo" color="#98ca3f"></box-icon>
            <div>
              <h3 className="skills__name">GitHub MCP</h3>
            </div>
          </div>
          <div className="skills__data">
            <i className="bx bx-cloud-upload"></i>
            <div>
              <h3 className="skills__name">Vercel MCP</h3>
            </div>
          </div>
          <div className="skills__data">
            <i className="bx bx-shield-quarter"></i>
            <div>
              <h3 className="skills__name">SonarCloud MCP</h3>
            </div>
          </div>
          <div className="skills__data">
            <i className="bx bx-shield"></i>
            <div>
              <h3 className="skills__name">SonarQube for IDE</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AITools;
